import { SBaseDisplay } from '@summit/core';

import { WorkersCompCode } from '@app/models/reports2/insurance/workers-comp-code.enum';
import { EboNameObject } from '../base-classes/ebo-name-object';
import { Tenant } from '../tenant/tenant';

export class EmployeePayrollGroup extends EboNameObject implements SBaseDisplay {
  tenantID: string;
  tenant: Tenant;
  archived: boolean;
  defaultWorkersCompCode: WorkersCompCode;
  //customField1: string;
  //customField2: string;
  //customField3: string;

  constructor(jsonData?: Partial<EmployeePayrollGroup>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData?.tenant) this.tenant = new Tenant(jsonData?.tenant);
    }
    this.defaultWorkersCompCode ??= WorkersCompCode.Unknown;
  }
  toShortString(): string {
    if (this.tenant) return `${this.tenant?.name}: ${this.name}`;
    return this.name;
  }
}
